module.exports = __webpack_public_path__ + "img/undraw_personal_opinions_re_qw29.e48edec3.png";